import { baseApiUrl } from '../../config/env';
import { fromObjectToParams } from '../../utils/filter.utils';

export const getRepriceApi = async (accessToken, params, selectedAirCloud, passengers) => {
  //let params = encodeURIComponent(JSON.stringify({"TripRequestKey":88608,"AirResponseKeyLeg1":"2c6b26ad-1474-4b30-83b8-4ebf7344858c","AirResponseKeyLeg2":"00000000-0000-0000-0000-000000000000","MultiBrandKeyLeg1":"00000000-0000-0000-0000-000000000000","MultiBrandKeyLeg2":"00000000-0000-0000-0000-000000000000"}));
  try {
    const body = {
      param: params,
    };
    if (selectedAirCloud) {
      body.selectedAir = JSON.stringify(selectedAirCloud);
    }
    if (passengers) {
      body.passengers = JSON.stringify(passengers);
    }
    const res = await fetch(`${baseApiUrl}/air/RePrice`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${accessToken}`,
      },
      body: new URLSearchParams(body).toString(),
    });
    const resultJson = await res.json();
    return resultJson;
  } catch (error) {
    throw new Error('Reprice API failed');
  }
};

export const getPurchaseApi = async (acccessToken, params, selectionData) => {
  try {
    let paramsStr;
    if (
      selectionData?.selectedCar &&
      selectionData?.selectedCar.length > 0 &&
      selectionData?.selectedAir &&
      Object.keys(selectionData?.selectedAir)?.length
    ) {
      paramsStr = `travelCartParam=${params}&selectedAir=${encodeURIComponent(
        JSON.stringify(selectionData?.selectedAir)
      )}&selectedCar=${encodeURIComponent(selectionData?.selectedCar)}`;
    } else if (selectionData?.selectedCar && selectionData?.selectedCar.length > 0) {
      paramsStr = `travelCartParam=${params}&selectedCar=${encodeURIComponent(
        selectionData?.selectedCar
      )}`;
    } else if (selectionData?.selectedAir && Object.keys(selectionData?.selectedAir)?.length) {
      paramsStr = `travelCartParam=${params}&selectedAir=${encodeURIComponent(
        JSON.stringify(selectionData?.selectedAir)
      )}`;
    } else {
      paramsStr = `travelCartParam=${params}`;
    }
    __DEV__ && console.log('Params str -> ', { paramsStr });
    const res = await fetch(`${baseApiUrl}/cart/Purchase_New`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${acccessToken}`,
      },
      body: paramsStr,
    });
    // Handle non-OK responses
    if (!res.ok) {
      const errorText = await res.text();
      return {
        ok: res.ok,
        errorText: errorText,
      };
    }

    // If the response is OK, parse and return the JSON
    const resultJson = await res.json();
    resultJson.ok = res.ok;
    return resultJson;
  } catch (error) {
    throw new Error('getPurchaseApi failed');
  }
};

export const getTripConfirmationApi = async (accessToken, tripKey, travelRequestId) => {
  if (travelRequestId == null) {
    travelRequestId = 0;
  }
  const queryParam =
    `tripId=` + tripKey + `&travelRequestId=${travelRequestId}&userToken=null&oldTrip=true`;
  const res = await fetch(`${baseApiUrl}/trip/view?` + queryParam, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!res.ok) {
    throw new Error('error loading trip view by tripId');
  }
  const resultJson = await res.json();
  return resultJson;
};

export const cancelTripApi = async (acccessToken, params) => {
  //let params = encodeURIComponent(JSON.stringify({"TripRequestKey":88608,"AirResponseKeyLeg1":"2c6b26ad-1474-4b30-83b8-4ebf7344858c","AirResponseKeyLeg2":"00000000-0000-0000-0000-000000000000","MultiBrandKeyLeg1":"00000000-0000-0000-0000-000000000000","MultiBrandKeyLeg2":"00000000-0000-0000-0000-000000000000"}));
  try {
    console.log(params);
    const res = await fetch(`${baseApiUrl}/cart/cancelPNRs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${acccessToken}`,
      },
      body: params,
    });
    const resultJson = await res.json();
    return resultJson;
  } catch (error) {
    throw new Error('cancel API failed');
  }
};
